/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit'
import * as liveReportServiceAPI from 'liveReportService'
import { LiveReportServiceErrorResponse } from 'liveReportService'
import { DashboardVo } from 'vo/Dashboard'
import { Dashboard } from 'schemas/DashboardSchema'

type GetDashboardByReportIdParam = {
  id: string
}

export const getDashboardByReportId = createAsyncThunk<
  Dashboard,
  GetDashboardByReportIdParam,
  { rejectValue: LiveReportServiceErrorResponse | undefined }
>('liveReport/getDashboardByReportId', async ({ id }, { rejectWithValue }) => {
  try {
    const { data } = await liveReportServiceAPI.getDashboardByReportId(id)
    const transformedData = DashboardVo(data)
    return transformedData
  } catch (err: unknown) {
    return rejectWithValue((err as any)?.response?.data)
  }
})

export const getCsrfToken = createAsyncThunk<
  { csrfToken: string },
  void,
  { rejectValue: LiveReportServiceErrorResponse | undefined }
>('liveReport/getCsrfToken', async (_, { rejectWithValue }) => {
  try {
    const { data } = await liveReportServiceAPI.csrfToken()
    return data
  } catch (err: unknown) {
    // @ts-ignore
    return rejectWithValue((err as any)?.response?.data)
  }
})

type LoginParam = {
  email: string
  reportKey: string
}

export const login = createAsyncThunk<
  '',
  LoginParam,
  { rejectValue: LiveReportServiceErrorResponse | undefined }
>('liveReport/login', async ({ email, reportKey }: LoginParam, { rejectWithValue }) => {
  try {
    const { data } = await liveReportServiceAPI.login({ email, reportKey })
    return data
  } catch (err: unknown) {
    return rejectWithValue((err as any)?.response?.data)
  }
})

export const logout = createAsyncThunk<
  '',
  void,
  { rejectValue: LiveReportServiceErrorResponse | undefined }
>('liveReport/logout', async (_, { rejectWithValue }) => {
  try {
    const { data } = await liveReportServiceAPI.logout()
    return data
  } catch (err: unknown) {
    return rejectWithValue((err as any)?.response?.data)
  }
})

export const getReportConfig = createAsyncThunk<
  { anonymous: boolean },
  void,
  { rejectValue: LiveReportServiceErrorResponse | undefined }
>('liveReport/getReportConfig', async (_, { rejectWithValue }) => {
  try {
    const { data } = await liveReportServiceAPI.getReportConfig()
    return data
  } catch (err: unknown) {
    return rejectWithValue((err as any)?.response?.data)
  }
})

export const heartbeat = createAsyncThunk('liveReport/heartbeat', async () => {
  try {
    await liveReportServiceAPI.heartbeat()
  } catch (error) {
    console.error(error)
  }
})
